module.exports = __webpack_public_path__ + "static/media/arrow-left.a814ff4c.svg";